import React from 'react';
import { Collapse } from '@mui/material';
import { useSelector } from 'react-redux';

// LOCAL IMPORTS
import { sideMenuRoutes } from '../../../router/config';
import { normalizeRole, ROLES } from '@/router/roles';
import { ListIcon } from '../ListIcon';
import { Logout } from '../Logout';
import { Logo } from '../Logo';

/*************************** SIDE MENU DESKTOP *****************************/
export const SideMenuDesktop = ({ isShow, setIsShow }) => {
  const currentUser = useSelector(state => state?.currentUser?.currentUser);
  const role = normalizeRole(currentUser?.userRole) ?? ROLES.CREATOR;
  const routes = sideMenuRoutes[role] ?? [];
  return (
    <div className={`relative h-screen border-r border-[#C5D3DF] bg-white shadow-md transition-all duration-300 max-md:absolute max-md:z-50 ${isShow ? 'w-[230px] base:w-[280px]' : 'w-0'}`}>

      <Collapse in={isShow} timeout={300}>
        <div className={`divide-y h-screen divide-neutral-light2`}>
          <Logo />

          <div className='h-[calc(100%-170px)] md:h-[calc(100%-220px)] flex-grow overflow-y-auto overflow-x-hidden'>
            <div className='flex flex-col'>
              {routes?.map((route, index) => {
                return <ListIcon setIsShow={setIsShow} route={route} text={route.text} key={index} />;
              })}
            </div>
          </div>

          <Logout />
        </div>
      </Collapse>
    </div>
  );
};
